
import moment from 'moment'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { withLegacyRouter } from '../../../../decorators'
import { toFHIR, fromFHIR } from '../../../../lib/Proxy/utilizationexpense'
import * as Card from '../../../shared/card'
import CrudTable from '../../../shared/CrudTable'
import FriendlyDate from '../../../shared/Date/FriendlyDate'
import ConfirmationDeleteDialog from '../../../shared/DeleteDialog/ConfirmationDeleteDialog'

import UtilizationExpenseForm from './form'

const mkSpec = patientId => ({
  type: 'Activity',
  form: UtilizationExpenseForm,
  urls: {
    get: () => `/patients/${patientId}/lists/utilizationexpense`,
    create: () => `/patients/${patientId}/lists/utilizationexpense`,
    update: entry =>
      `/patients/${patientId}/lists/utilizationexpense/${entry.id}`,
    delete: entry =>
      `/patients/${patientId}/lists/utilizationexpense/${entry.id}`
  },
  mapFns: {
    toForm: fromFHIR,
    toFhir: entry => toFHIR(entry, patientId)
  },
  table: [
    {
      title: 'Category',
      displayFn: x => x.category
    },
    {
      title: 'Start Date',
      displayFn: x => (
        <FriendlyDate
          date={
            (typeof x.startDate === 'string' && x.startDate) ||
            (typeof x.startDate === 'object' &&
              moment(x.startDate).format('MM/DD/YYYY')) ||
          ''
          }
        />
      ),
      sortBy: 'startDate'
    },
    {
      title: 'Type',
      displayFn: x => x.type
    },
    {
      title: 'Hard/Soft',
      displayFn: x => x.hardSoft
    },
    {
      title: 'Amount',
      displayFn: x => (x.amount ? `$ ${x.amount}` : '')
    }
  ]
})

function UtilizationExpense ({ params, patientId }) {
  const ptId = params ? params.id : patientId
  const spec = mkSpec(patientId)

  return (
    <Card.Card>
      <Card.Header>
        <h2>Utilization & Expense</h2>
      </Card.Header>
      <div style={{ padding: '0 1rem 1rem' }}>
        <CrudTable
          labelButton='Activity'
          labelNoEntries='Activities'
          urlFns={spec.urls}
          entryType={spec.type}
          entrySet={ptId}
          tableDefinition={spec.table}
          mapFns={spec.mapFns}
          form={spec.form}
          deleteDialog={ConfirmationDeleteDialog}
        />
      </div>
    </Card.Card>
  )
}

UtilizationExpense.contextTypes = {
  dispatch: PropTypes.instanceOf(Object)
}

const mapStateToProps = redux => ({
  patientId: redux.globalVars.params.id
})

const mapDispatchToProps = dispatch => ({
  dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(withLegacyRouter(UtilizationExpense))
